<!-- Fullscreen.svelte -->

<script>
  import { onMount } from "svelte";
  /* ____________ Mobile Detection ____________ */
  import UA from "ua-parser-js";
  const ua = new UA();
  // initial state
  let isMobile = ua.getResult().device["type"] == "mobile";
  let isFull = false;
  let fsContainer = null;

  onMount(() => {
    const handleFullscreenChange = () => {
      isFull = !!(
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement
      );
    };

    let eventName = "fullscreenchange";
    if (!document.fullscreenEnabled) {
      if (document.webkitFullscreenEnabled) {
        // Safari, Chrome and others
        eventName = "webkitfullscreenchange";
      } else if (document.mozFullScreenEnabled) {
        // Firefox
        eventName = "mozfullscreenchange";
      } else if (document.msFullscreenEnabled) {
        // IE / Edge
        eventName = "MSFullscreenChange";
      }
    }

    document.addEventListener(eventName, handleFullscreenChange);

    return () => {
      document.removeEventListener(eventName, handleFullscreenChange);
    };
  });

  // boring plain js fullscreen support stuff below
  const noop = () => {};

  const fullscreenSupport = !!(
    document.fullscreenEnabled ||
    document.webkitFullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.msFullscreenEnabled ||
    false
  );

  const exitFullscreen = (
    document.exitFullscreen ||
    document.mozCancelFullScreen ||
    document.webkitExitFullscreen ||
    document.msExitFullscreen ||
    noop
  ).bind(document);

  const requestFullscreen = () => {
    const requestFS = (
      fsContainer.requestFullscreen ||
      fsContainer.mozRequestFullScreen ||
      fsContainer.webkitRequestFullscreen ||
      fsContainer.msRequestFullscreen ||
      noop
    ).bind(fsContainer);
    requestFS();
  };

  const toggleFullscreen = () => {
    if (!fullscreenSupport) return;

    if (isFull) {
      exitFullscreen();
    } else {
      requestFullscreen(fsContainer);
    }
    isFull = !isFull;
  };

  const handleFullscreen = (e) => {
    if (!fullscreenSupport) return;
    requestFullscreen(fsContainer);
    isFull = true;
  };

  $: icon = isFull ? "fullscreen_exit" : "fullscreen";
</script>

<main class="fs" class:isFull bind:this={fsContainer}>
  {#if fullscreenSupport && !isFull && isMobile}
    <div on:click={handleFullscreen} />
  {/if}
  <slot {isFull} />
</main>

<style>
  main,
  div {
    padding: 0;
    margin: 0;
    width: 100vw;
    height: 100vh;
  }

  div {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99999;
  }
</style>
